import { Outlet } from 'react-router-dom';

import { Page } from '../../../components';
import { ExamEventPreviewBanner, ExamEventPreviewHeader } from '../components';

export default function ExamEventPreviewLayout() {
  return (
    <Page containerClassName='flex flex-col'>
      <ExamEventPreviewBanner />
      <ExamEventPreviewHeader />
      <Outlet />
    </Page>
  );
}
